import React, { useState, useEffect } from 'react';
import { useExperiences } from 'query/hooks';

import ShoppingExperience from '../containers/shopping/experience/item';

export default function Experience() {
    const experiences = useExperiences()?.data || [];

    const [update, setUpdate] = useState(false);

    useEffect(() => {
        if (update) setUpdate(false);
    }, [update]);

    return (
        <div className="page-wrapper page-amount">
            {experiences?.map((experience, index) => (
                <ShoppingExperience
                    key={experience.id}
                    color={experience.color}
                    experience={experience}
                />
            ))}
        </div>
    );
}
